import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import ApiClient from "../utils/api-client";
import { apiErrorMessage } from "../utils/api-error";
import { Logo } from "../components/Logo";
import { fieldClass } from "./billing/billing";

const ConfirmEmail = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token") || "";
  const [message, setMessage] = useState<string>(token ? t("confirm.working") : t("confirm.missing"));
  const [email, setEmail] = useState("");
  const [resending, setResending] = useState(false);

  useEffect(() => {
    if (!token) {
      return;
    }
    let cancel = false;
    ApiClient.confirmEmail(token)
      .then((response) => {
        if (!cancel) {
          setMessage(response?.data?.message || t("confirm.done"));
        }
      })
      .catch((error) => {
        if (!cancel) {
          setMessage(apiErrorMessage(error, t("confirm.failed")));
        }
      });
    return () => {
      cancel = true;
    };
  }, [token, t]);

  const resend = async (event: React.FormEvent) => {
    event.preventDefault();
    setResending(true);
    try {
      const response = await ApiClient.resendConfirmation(email);
      setMessage(response?.data?.message || t("confirm.resent"));
    } catch (error) {
      setMessage(apiErrorMessage(error, t("confirm.failed")));
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-md">
        <Logo className="max-w-full" />
        <h2 className="mt-6 text-center text-3xl leading-9 font-extrabold text-gray-900">
          {t("confirm.header")}
        </h2>
        <p className="mt-4 text-center text-sm text-gray-700">{message}</p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form onSubmit={resend}>
            <label htmlFor="resend-email" className="block text-sm font-medium text-gray-700">
              {t("login.email")}
            </label>
            <input
              id="resend-email"
              type="email"
              required
              value={email}
              onChange={(event) => setEmail(event.target.value)}
              className={`${fieldClass} mt-1`}
            />
            <button
              type="submit"
              disabled={resending}
              className="mt-4 w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-500"
            >
              {t("confirm.resend")}
            </button>
          </form>
          <p className="mt-6 text-center text-sm">
            <Link to="/" className="text-indigo-600 hover:text-indigo-500">
              {t("register.back-to-login")}
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default ConfirmEmail;
